import { FormControl, FormLabel } from "@/components/essentials/form-control";
import { Select } from "@/components/essentials/select";
import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { formLabelShipmentYearFilterTestId, selectShipmentYearFilterTestId } from "./const";
import { type ShipmentYearFilterFormValue } from "./type";

export interface ShipmentYearFilterFormProps {
  readonly years: string[];
}

export const shipmentFilterYearName = "shipmentYearFilter";

export const ShipmentYearFilterForm: FC<ShipmentYearFilterFormProps> = ({ years }) => {
  const { register } = useFormContext<ShipmentYearFilterFormValue>();

  return (
    <FormControl id="shipment-year-filter">
      <FormLabel data-testid={formLabelShipmentYearFilterTestId}>発送年で絞り込む</FormLabel>
      <Select data-testid={selectShipmentYearFilterTestId} {...register(shipmentFilterYearName)} variant="mono">
        {years.map((year, key) => (
          <option key={key} value={year}>
            {year}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};
